import { MutationList } from './mutation-list'
import {MutationTree} from "vuex";
import {modal} from "@/store/types";

export type Mutations <S = modal> = {
    [MutationList.SET_MODAL_MESSAGE](state: S, payload: string): void;
    [MutationList.SET_MODAL_FOOTER_MESSAGE](state: S, payload: string): void;
    [MutationList.SET_MODAL_HEADER_MESSAGE](state: S, payload: string): void;
    [MutationList.SET_MODAL_TYPE](state: S, payload: number): void;
    [MutationList.SET_MODAL_VISIBILITY_FALSE](state: S): void;
    [MutationList.SET_MODAL_VISIBILITY_TRUE](state: S): void;
    [MutationList.SET_SMALL_MODAL_MESSAGE_VISIBLE_FALSE](state: S): void;
    [MutationList.SET_SMALL_MODAL_MESSAGE_VISIBLE_TRUE](state: S): void;
    [MutationList.SET_SMALL_MODAL_MESSAGE_MESSAGE](state: S, payload: string): void;
    [MutationList.SET_SMALL_MODAL_MESSAGE_TITLE](state: S, payload: string): void;
    [MutationList.SET_AUTH_MODAL_VISIBILITY_FALSE](state: S): void;
    [MutationList.SET_AUTH_MODAL_VISIBILITY_TRUE](state: S): void;
    [MutationList.SET_SEARCH_MODAL_VISIBILITY_FALSE](state: S): void;
    [MutationList.SET_SEARCH_MODAL_VISIBILITY_TRUE](state: S): void;
    [MutationList.SELECT_LOADING_MODAL](state: S, payload: string): void;
    /* eslint-disable-next-line */
    [MutationList.SELECT_MESSAGING_MODAL](state: S, payload: {message: string, header: string}): void;
    /* eslint-disable-next-line */
    [MutationList.SELECT_SMALL_MODAL](state: S, payload: {message: string, title: string}): void;
}

export const mutations: MutationTree<modal> & Mutations = {
    [MutationList.SET_MODAL_TYPE] (state, payload) {
        state.modalType = payload
    },
    [MutationList.SET_MODAL_MESSAGE] (state, payload) {
        state.modalMessage = payload
    },
    [MutationList.SET_MODAL_VISIBILITY_FALSE] (state){
        state.show = false;
    },
    [MutationList.SET_MODAL_VISIBILITY_TRUE] (state){
        state.show = true;
    },
    [MutationList.SET_AUTH_MODAL_VISIBILITY_FALSE](state){
        state.authModalShow = false;
    },
    [MutationList.SET_AUTH_MODAL_VISIBILITY_TRUE](state){
        state.authModalShow = true;
    },
    [MutationList.SET_SEARCH_MODAL_VISIBILITY_TRUE](state){
        state.servicesModalShow = true;
    },
    [MutationList.SET_SEARCH_MODAL_VISIBILITY_FALSE](state){
        state.servicesModalShow = false;
    },
    [MutationList.SET_MODAL_FOOTER_MESSAGE](state, payload) {
        state.modalFooterMessage = payload;
    },
    [MutationList.SET_MODAL_HEADER_MESSAGE](state, payload) {
        state.modalHeaderMessage = payload;
    },
    [MutationList.SELECT_LOADING_MODAL](state, payload) {
        state.modalType = 1;
        state.modalFooterMessage = payload;
        state.show = true;
    },
    [MutationList.SELECT_MESSAGING_MODAL](state, payload) {
        state.modalType = 0;
        state.modalMessage = payload.message;
        state.modalHeaderMessage = payload.header;
        state.show = true;
    },
    [MutationList.SET_SMALL_MODAL_MESSAGE_VISIBLE_FALSE](state) {
        state.smallModalMessageVisibility = false;
    },
    [MutationList.SET_SMALL_MODAL_MESSAGE_VISIBLE_TRUE](state) {
        state.smallModalMessageVisibility = true;
    },
    [MutationList.SET_SMALL_MODAL_MESSAGE_TITLE](state, payload) {
        state.smallModalMessageTitle = payload;
    },
    [MutationList.SET_SMALL_MODAL_MESSAGE_MESSAGE](state, payload) {
        state.smallModalMessageMessage = payload;
    },
    [MutationList.SELECT_SMALL_MODAL](state, payload) {
        state.smallModalMessageMessage = payload.message;
        state.smallModalMessageTitle = payload.title;
        state.smallModalMessageVisibility = true;
    }
}